import React from 'react';
import {
  LayoutGrid, Calendar, MapPin, Landmark, ConciergeBell, Signpost, Home,
  Wifi, Coffee, Snowflake, Tv, ShowerHead, Luggage, Compass, Camera, Wine,
  Waves, Flower2, Users, Heart, Utensils, ShoppingBag, Bike, Dumbbell, Car,
  Sparkles, Bell, Star, Phone, Plus, Bus, Scissors, Image as ImageIcon, Globe,
  Menu, X, ChevronLeft, ChevronRight, ArrowRight, Search, Map, User, Instagram,
  Facebook, Check, ShieldCheck, Smartphone, TrendingUp, Settings, Leaf, Play,
  SlidersHorizontal, MapPinned, Clock, Bath, Croissant, Key, DoorOpen, PawPrint,
  FileText, Ambulance, Train, QrCode, BellRing, Gift, BookOpen, Sailboat, Music,
  Store, Flame, Mail, ArrowUpRight
} from 'lucide-react';

// Registry maps string keys (API friendly) -> lucide components.
const registry = {
  grid: LayoutGrid, calendar: Calendar, mapPin: MapPin, landmark: Landmark,
  concierge: ConciergeBell, signpost: Signpost, home: Home, wifi: Wifi,
  coffee: Coffee, snowflake: Snowflake, tv: Tv, shower: ShowerHead,
  luggage: Luggage, compass: Compass, camera: Camera, wine: Wine, waves: Waves,
  flower: Flower2, users: Users, heart: Heart, utensils: Utensils,
  shopping: ShoppingBag, bike: Bike, dumbbell: Dumbbell, car: Car,
  sparkles: Sparkles, bell: Bell, star: Star, phone: Phone, plus: Plus,
  bus: Bus, scissors: Scissors, image: ImageIcon, globe: Globe, menu: Menu,
  close: X, chevronLeft: ChevronLeft, chevronRight: ChevronRight,
  arrowRight: ArrowRight, search: Search, map: Map, user: User,
  instagram: Instagram, facebook: Facebook, check: Check, shield: ShieldCheck,
  smartphone: Smartphone, trending: TrendingUp, settings: Settings, leaf: Leaf,
  play: Play, sliders: SlidersHorizontal, mapPinned: MapPinned, clock: Clock,
  bath: Bath, croissant: Croissant, key: Key, door: DoorOpen, paw: PawPrint,
  file: FileText, ambulance: Ambulance, train: Train, qr: QrCode,
  bellRing: BellRing, gift: Gift, book: BookOpen, sailboat: Sailboat,
  music: Music, store: Store, flame: Flame, mail: Mail, arrowUpRight: ArrowUpRight
};

export function Icon({ name, className = '', size = 24, strokeWidth = 2, ...rest }) {
  const Cmp = registry[name] || LayoutGrid;
  return <Cmp className={className} size={size} strokeWidth={strokeWidth} {...rest} />;
}

export default Icon;
